import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';

export function getPlatform(): string {
  if (Platform.OS === 'web') return 'Web Browser';
  try {
    const systemName = DeviceInfo.getSystemName(); // 'Android' / 'iOS' / 'iPadOS'
    const systemVersion = DeviceInfo.getSystemVersion(); // e.g. '15', '18.3'
    const isTablet = DeviceInfo.isTablet();
    if (Platform.OS === 'android') {
      return isTablet
        ? `Android Tablet (${systemVersion})`
        : `Android (${systemVersion})`;
    }
    // iOS / iPadOS: systemName differentiates 'iOS' vs 'iPadOS'
    return `${systemName} (${systemVersion})`;
  } catch {
    // Fallback when DeviceInfo methods are unavailable
    return Platform.OS === 'android' ? 'Android' : 'iOS';
  }
}
